/**
 * Superpagg
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 function updateOnlineStatus(event) {
    if (navigator.onLine) {
        $(".offline-top-alert").fadeOut();
    } else {
        $(".offline-top-alert").fadeIn();
    }
}

window.addEventListener('load', updateOnlineStatus);
window.addEventListener('online', updateOnlineStatus);
window.addEventListener('offline', updateOnlineStatus);
